import { LOCATION_CHANGE } from 'react-router-redux';
import * as TYPES from '../../constants/types';

const initialState = {
  data: null,
  loading: false,
  loaded: false,
  error: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case TYPES.GET_DOCTOR_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
      };

    case TYPES.GET_DOCTOR_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        loaded: true,
      };

    case TYPES.GET_DOCTOR_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload.error,
      };

    case LOCATION_CHANGE:
      return initialState;

    default:
      return { ...state };
  }
}
